import configureAnalytics, { AnalyticsInstance, AnalyticsPlugin } from "analytics";
import mixpanel from "mixpanel-browser";
import AppConfig from "./App.config";

export let analytics: AnalyticsInstance = configureAnalytics({});

if (AppConfig.analytics.environments.includes(process.env.TARGET_ENV)) {
    analytics = configureAnalytics({
        app: AppConfig.portalName,
        plugins: [
            // eslint-disable-next-line no-use-before-define
            mixpanelPlugin({
                debug: true,
                // eslint-disable-next-line camelcase
                ignore_dnt: true,

                persistence: "localStorage",

                token: AppConfig.analytics.plugins.mixpanel.token || "",

                // eslint-disable-next-line camelcase
                track_pageview: true,
            }),
        ],
    });
}

interface MixpanelConfig {
    token: string;
    debug?: boolean;
    track_pageview?: boolean;
    persistence?: string;

    // DNT: Do Not Track
    ignore_dnt?: boolean;
}

// eslint-disable-next-line require-jsdoc
function mixpanelPlugin(mixpanelConfig: MixpanelConfig): AnalyticsPlugin {
    return {
        config: mixpanelConfig,

        identify: ({ payload }) => {
            const { userId, traits } = payload;

            mixpanel.identify(userId);
            mixpanel.people.set(traits);
        },

        // eslint-disable-next-line require-jsdoc
        initialize: ({ config }) => {
            const { token, ...options } = config;

            mixpanel.init(token, options);
        },
        name: "mixpanel",
        page: ({ payload }) => {
            const { properties } = payload;

            mixpanel.track_pageview(properties);
        },
        track: ({ payload }) => {
            const { event, properties } = payload;

            mixpanel.track(event, properties);
        },
    };
}
